<app-header [forceLightBackground]="true"></app-header>
<div class="provider-my-request">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="provider-my-request--sidebar-col">
      <app-provider-sidebar></app-provider-sidebar>
    </div>
    <div class="provider-my-request--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <app-my-request-shared></app-my-request-shared>
    </div>
  </div>
</div>
